module.exports = "/virtual-football-league/img/amblems/left/logos/AtleticoMadrid.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/logos/AtleticoMadrid.png
// module id = 2052
// module chunks = 4